import { useState } from "react";

import { getContentHeight } from "../../../../utils/textUtils";

import ArrowButton from "../widgets/ArrowButton";
import PageInfoBar from "../widgets/PageInfoBar";
import ParagraphButton from "./ParagraphButton";
import CorrectOverlay from "../widgets/CorrectOverlay";

const CommonPage = ({
  children,
  handlePreviousPage,
  handleNextPage,
  currentIndex,
  currentPage,
  totalNo,
  fontFamily = '"Pretendard", sans-serif',
  paragraph = null,
  overlayVisible = false,
  isCorrect = null,
  handleSubmit = null,
  isMobile = false,
}) => {
  const [paragraphModelOpen, setParagraphModalOpen] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        height: getContentHeight(isMobile),
        paddingRight: isMobile ? "20px" : "40px",
        paddingLeft: isMobile ? "10px" : "30px",
        fontFamily: fontFamily,
        backgroundColor: "#FFFFFF",
      }}
    >
      {/* 왼쪽 화살표 */}
      <ArrowButton
        direction="left"
        onClick={handlePreviousPage}
        visibleCondition={currentIndex > 0}
      />
      {children}
      <ArrowButton
        direction="right"
        onClick={handleNextPage}
        visibleCondition={true}
      />
      <PageInfoBar currentNo={currentIndex + 1} totalNo={totalNo} />
      {paragraph !== null && (
        <ParagraphButton
          paragraphModelOpen={paragraphModelOpen}
          setParagraphModalOpen={setParagraphModalOpen}
          paragraph={paragraph}
        />
      )}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          opacity: overlayVisible ? 1 : 0, // Fade-in/out
          visibility: overlayVisible ? "visible" : "hidden", // DOM에서 숨김
          transition: "opacity 200ms ease-out, visibility 200ms",
        }}
      >
        <CorrectOverlay bool={isCorrect} />
      </div>
      {handleSubmit !== null && (
        <button
          style={{
            position: "absolute", // 부모(80% width) 안에서 절대 위치
            bottom: "80px", // 최하단으로부터 10px 떨어짐
            right: "60px", // 우측으로부터 10px 떨어짐
            padding: "10px 35px",
            backgroundColor: currentPage.isSubmitted ? "#EBEBEB" : "#2D2D2D",
            color: currentPage.isSubmitted === true ? "#737373" : "white",
            border: "none",
            fontSize: "18px",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={() => handleSubmit()}
        >
          제출하기
        </button>
      )}
    </div>
  );
};

export default CommonPage;
